export class Usuario {
    constructor(
        public uid?: number,
        public token?: string,
        public cpf_cnpj?: string,
        public senha?: string,
        public nome?: string,
        public email?: string,
        public foto?: string,
        public fotoURI?: any,
        public mantenedora?: number,
        public celular?: string,
        public telefone1?: string,
        public telefone2?: string,
        public telefones?: string,    // telefones agrupados
        public perfil?: any[],        // lista com os perfis
        public perfis?: string,       // nome dos perfis agrupados
        public transacao?: string[],
        public transacoes?: string,   // transações separadas por virgula
        public dataCadastro?: string,
        public inativo?: boolean,
        public botaoAcao?: string,
        public botaoStatus?: string,
        public status?: number,
        public listaCodSistemaGestao?: string,
        public listaSiglaSistemaGestao?: string,
        public razaoSocial?: string,
        public codTipoPerfil?: number,
        public termoDeUso?: number
    ) {
        this.uid = this.uid ? this.uid : 0;
        this.termoDeUso = this.termoDeUso ? this.termoDeUso : 0;
        this.token = this.token ? this.token : '';
        this.cpf_cnpj = this.cpf_cnpj ? this.cpf_cnpj : '';
        this.senha = this.senha ? this.senha : '';
        this.nome = this.nome ? this.nome : '';
        this.email = this.email ? this.email : '';
        this.foto = this.foto ? this.foto : '';
        this.fotoURI = this.fotoURI ? this.fotoURI : '';
        this.mantenedora = this.mantenedora ? this.mantenedora : 0;
        this.celular = this.celular ? this.celular : '';
        this.telefone1 = this.telefone1 ? this.telefone1 : '';
        this.telefone2 = this.telefone2 ? this.telefone2 : '';
        this.perfil = this.perfil ? this.perfil : [];
        this.perfis = this.perfis ? this.perfis : '';
        // this.transacao = this.transacao ? this.transacao : [];
        // this.transacoes = this.transacoes ? this.transacoes : '';
        this.inativo = this.inativo ? this.inativo : false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/models/usuario.ts